import {Component, ViewChild, HostListener, Input, ElementRef} from '@angular/core';

declare var $:any;

@Component({
  selector: 'ubi-back-top',
  styleUrls: ['./ubiBackTop.scss'],
  template: `
    <i #baBackTop class="fa fa-angle-up back-top ba-back-top" title="Back to Top"></i>
  `
})
export class UbiBackTop {

  @Input() position:number = 400;
  @Input() showSpeed:number = 500;
  @Input() moveSpeed:number = 1000;

  @ViewChild('baBackTop') _selector:ElementRef;

  ngAfterViewInit () {
    this._onWindowScroll();
  }

  @HostListener('click')
  _onClick():boolean {
    $('html, body').animate({scrollTop:0}, {duration:this.moveSpeed});
    return false;
  }

  @HostListener('window:scroll')
  _onWindowScroll():void {
    let el = this._selector.nativeElement;
    window.scrollY > this.position ? $(el).fadeIn(this.showSpeed) : $(el).fadeOut(this.showSpeed);
  }
}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/theme/components/ubiBackTop/ubiBackTop.component.ts